import { HERO_LOGO_IMAGE } from "@/utils/images";

export default function HeroServiceLogo() {
  return (
    <img
      src={HERO_LOGO_IMAGE}
      alt="Mesa de Servicios"
      className="mx-auto mb-5 w-[240px] rounded-2xl shadow-2xl sm:w-[300px] lg:mb-7 lg:w-[400px]"
    />
  );
}
